import { Link } from "react-router-dom";
import AuthShell from "./AuthShell";
import AuthButtonLink from "./AuthButtonLink";
import a from "./auth.module.css";

export default function RegistrationByLinkSuccess({
  clubName,
  email,
  loginPath,
  backLabel = "Назад",
}) {
  const normalizedEmail = String(email || "").trim().toLowerCase();

  return (
    <AuthShell
      modern
      wide
      backTo={loginPath}
      backLabel={backLabel}
      showSwitcher={false}
      clubTag={clubName}
      cardTitle="Заявка отправлена"
      hint="Осталось дождаться подтверждения тренера — затем придёт письмо для входа."
    >
      <div className={a.regLinkSuccess}>
        <div className={a.regLinkSuccessIcon} aria-hidden>
          ✓
        </div>

        <p className={a.regLinkSuccessLead}>
          Заявка принята{clubName ? ` в клуб «${clubName}»` : ""}. Обычно проверка
          занимает от нескольких часов до одного рабочего дня.
        </p>

        <ol className={a.regLinkSuccessSteps}>
          <li>
            <span className={a.regLinkSuccessStepNum}>1</span>
            <span>Тренер или администратор проверит заявку</span>
          </li>
          <li>
            <span className={a.regLinkSuccessStepNum}>2</span>
            <span>
              На email придёт ссылка — задайте пароль и активируйте доступ
            </span>
          </li>
          <li>
            <span className={a.regLinkSuccessStepNum}>3</span>
            <span>В личном кабинете — расписание, абонементы и новости клуба</span>
          </li>
        </ol>

        {normalizedEmail ? (
          <div className={a.regLinkSuccessEmail}>
            <span className={a.regLinkSuccessEmailLabel}>Письмо с активацией</span>
            <strong>{normalizedEmail}</strong>
          </div>
        ) : (
          <p className={a.regLinkSuccessWarn}>
            Если письмо не пришло в течение суток — свяжитесь с клубом и уточните
            статус заявки.
          </p>
        )}

        <div className={a.regLinkSuccessActions}>
          <AuthButtonLink to={loginPath}>Ко входу</AuthButtonLink>
          <p className={a.regLinkSuccessFoot}>
            Уже подтвердили заявку?{" "}
            <Link to={loginPath} className={a.footerLinksModern}>
              Войти в кабинет
            </Link>
          </p>
        </div>
      </div>
    </AuthShell>
  );
}
